/* REMOVE ANSWER */
export const REMOVE_QUIZZ = "REMOVE_QUIZZ"
export const REMOVE_QUIZZ_SUCCESS = "REMOVE_QUIZZ_SUCCESS"
export const REMOVE_QUIZZ_CLEAN = "REMOVE_QUIZZ_CLEAN"
export const REMOVE_QUIZZ_ERROR = "REMOVE_QUIZZ_ERROR"
